import styled from 'styled-components';

export const CheckpointWrapper = styled.span`
  color: ${({ theme }) => theme.colors.green6};
`;
